import React, { useState } from 'react';

const useGeolocation = () => {
  const [coordinates, setCoordinates] = useState({
    latitude: null,
    longitude: null,
  });
  const [error, setError] = useState(null);

  const getCoordinates = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCoordinates({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          const cordinate = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          localStorage.setItem('coordinate', JSON.stringify(cordinate));
        },
        (err) => {
          setError(err.message);
        },
      );
    } else {
      setError('Geolocation is not supported by this browser.');
    }
  };

  return { coordinates, error, getCoordinates };
};

export default useGeolocation;
